import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { PRIMARY_COLORS } from '../../../themes/light';

export const Container = styled('div')(({ theme }) => ({
  maxWidth: '33vw',
  width: '700px',
  padding: theme.spacing(2),
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  maxWidth: 700,
  margin: 'auto',
  padding: theme.spacing(4),
}));

export const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const DropZone = styled(Box)(({ theme }) => ({
  border: `1px dashed ${theme.palette.grey[400]}`,
  padding: theme.spacing(4),
  textAlign: 'center',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[50],
}));

export const InstructionText = styled(Box)(({ theme }) => ({
  fontSize: '20px',
  fontFamily: 'Calibre',
  lineHeight: 1.6,
  color: theme.palette.text.primary,

  '*': {
    fontFamily: 'Calibre',
    fontSize: '20px',
    lineHeight: 1.6,
    color: theme.palette.text.primary,
  },

  h4: {
    fontSize: '28px',
    fontWeight: 600,
    fontFamily: 'Financier',
  },
}));

export const uploadBtnStyles = {
  mt: 3,
  mb: 2,
  backgroundColor: PRIMARY_COLORS.ALT_PRIMARY_COLOR,
  '&:hover': { backgroundColor: PRIMARY_COLORS.ALT_PRIMARY_HOVER_COLOR },
};

export const addBtnStyles = {
  backgroundColor: PRIMARY_COLORS.ALT_PRIMARY_COLOR,
  '&:hover': { backgroundColor: PRIMARY_COLORS.ALT_PRIMARY_HOVER_COLOR },
};
